/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_Company_NameInputs */

const et_difference_company_name = /** @type {(inputs: Difference_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie Ettevõte`)
};

const en_difference_company_name = /** @type {(inputs: Difference_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Company`)
};

/**
* | output |
* | --- |
* | "Your Company" |
*
* @param {Difference_Company_NameInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_company_name = /** @type {((inputs?: Difference_Company_NameInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_Company_NameInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_company_name(inputs)
	return en_difference_company_name(inputs)
});